import React from 'react'

interface CodeProps extends Omit<React.HTMLAttributes<HTMLElement>, 'className'> {
  children: React.ReactNode;
}

export function Code ({ children, ...props }: CodeProps) {
  return (
    <code
      {...props}
      className='body leading-none text-nowrap inline-block px-1 py-0.5 rounded-md bg-gray-100 border border-gray-200 font-mono'
    >
      {children}
    </code>
  )
}
